// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sm-input-long[data-v-57aa4b56] {\n  width: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
